import React from "react";
import { Button, FormControl, InputGroup } from "react-bootstrap";
import { useMediaQuery } from "react-responsive";

export default function ProductAra(props) {
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
  const {
    queryByName,
    setQueryByName,
    setProduct,
    setFeature,
    setFeatures,
    loading,
    navigate,
    rootCategory,
    showCategories,
    setShowCategories,
    setIsGridView,
    isGridView,
    filteredCategories,
  } = props;
  return (
    <InputGroup
      size="lg"
      className={isTabletOrMobile ? "mt-2 mb-1" : "m-2 pe-3"}
    >
      <Button
        variant="outline-primary"
        onClick={() => {
          setIsGridView((prev) => !prev);
        }}
      >
        {isGridView ? (
          <i className="fas fa-list" /> // List view icon
        ) : (
          <i className="fas fa-th" /> // Grid view icon
        )}
      </Button>
      <FormControl
        type="text"
        autoFocus={!isTabletOrMobile}
        value={queryByName}
        onChange={(e) => {
          if (!loading) {
            setQueryByName(e.target.value);
            setProduct("");
            setFeature("");
            setFeatures([]);
            navigate(`/category/order?rootCategory=`);
            setShowCategories(false);
          }
        }}
        placeholder="Ürün ara..."
        aria-label="Ürün ara"
        aria-describedby="button-search"
      ></FormControl>
      {filteredCategories && filteredCategories.length === 0 ? (
        <></>
      ) : rootCategory || queryByName ? (
        <>
          <Button
            variant="outline-primary"
            onClick={() => {
              setQueryByName("");
              setProduct("");
              setFeature("");
              setFeatures([]);
              navigate(`/category/order?rootCategory=`);
              setShowCategories(false);
            }}
          >
            {queryByName ? "Temizle" : rootCategory ? "Ürünler" : ""}
          </Button>
        </>
      ) : !showCategories ? (
        <Button
          variant="outline-primary"
          onClick={() => {
            setShowCategories(true);
          }}
        >
          Kategoriler
        </Button>
      ) : (
        <Button
          variant="outline-primary"
          onClick={() => {
            setQueryByName("");
            setProduct("");
            setFeature("");
            setFeatures([]);
            navigate(`/category/order?rootCategory=`);
            setShowCategories(false);
          }}
        >
          Ürünler
        </Button>
      )}
    </InputGroup>
  );
}
